module.exports = __webpack_public_path__ + "img/ios.a011cbc6.svg";